import { KeyValueModel } from "model/api";
import { EnumIndIEDest } from "model/enums";

export const IndIEDestMock: KeyValueModel[] = [
    new KeyValueModel(EnumIndIEDest.CONTRIBUINTE_ICMS, "Contribuinte ICMS"),
    new KeyValueModel(EnumIndIEDest.ISENTO, "Isento"),
    new KeyValueModel(EnumIndIEDest.NAO_CONTRIBUINTE, "Não contribuinte")
];